import React, {useEffect} from "react";
import {com, space,} from "../../../../provider_api";
import {KensuTable} from "../../../../components/table/KensuTable";
import {priceToString} from "../../../../util/PriceUtil";
import {shortDateTimeFormat2} from "../../../../util/DateTimeUtils";
import {TabbedPageHeader} from "../../../../components/TabbedPageHeader";
import {useNavigateWithParams} from "../../../../util/NavUtils";
import {useGetStripePayments} from "../../../../util/RpcHooks/GetStripePayments";
import IApiPaymentProto = space.kenko.proto.IApiPaymentProto;
import GetStripePaymentsRequest = com.onkensu.platform.billing.GetStripePaymentsRequest;
import {LoadingDots} from "../../../../util/UI/LoadingDots";

export const Payments = () => {

  const paymentsRpc = useGetStripePayments();
  const navigate = useNavigateWithParams();

  // Load attendees if editing. New events obviously have no signups.
  useEffect(() => {
    paymentsRpc.send(new GetStripePaymentsRequest({
      limit: 50
    }));
  }, [])

  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={'All Payments'} tabs={[
      {label: 'Billing Profile', link: '..'},
      {label: 'Payments', link: '.', isSelected: true},
    ]}/>

    <div className={'ProviderToolAreaContent'}>

      <h2>Payments</h2>
      <KensuTable<IApiPaymentProto>
          data={paymentsRpc.payments}
          onRowSelected={row => navigate(row.paymentId as string)}
          defaultSort={{ascending: false, columnIndex: 0}} // sort on date
          columns={[
            {label: 'Date', render: row => shortDateTimeFormat2(row.createdTimestampMs), sortOrder: row => row.createdTimestampMs},
            {label: 'Client', render: row => row?.userName},
            {label: 'Purchase', render: row => row.purchasedThingName},
            {label: 'Price', render: row => priceToString(row?.price, true)},
            {label: 'Payment Status', render: paymentStatusWidget},
          ]}/>

      {paymentsRpc.rpcState.state == 'pending' && !paymentsRpc.payments?.length && <div>Loading transactions<LoadingDots/></div>}
      {paymentsRpc.rpcState.state == 'success' && !paymentsRpc.payments?.length && <div>No transactions found.</div>}
      {paymentsRpc.rpcState.state == 'error' && <div className={'ErrorText'}>{paymentsRpc.rpcState.message}</div>}

    </div>
  </div>
}

export const paymentStatusWidget = (payment: IApiPaymentProto) => {

  if (payment.status == 'refunded') {
    return <div className="GrayHighlight">Refunded</div>
  }
  
  if (payment.status == 'complete') {
    return <div className="GreenHighlight">Success</div>
  }
  
  return payment.status;
}
